import { useTranslate } from '@tolgee/react';
import { EmptyState } from '~/components/empty/EmptyState';
import { PriceDevelopmentHistoryChart } from '~/components/charts/PriceDevelopmentHistoryChart';

interface Props {
  readonly priceHubbleHistory: {
    readonly value: number;
    readonly upperValue: number;
    readonly lowerValue: number;
    readonly date: number;
  }[];
  readonly isFlat?: boolean;
  readonly showFullText?: boolean;
}

export function PriceDevelopmentWidget(props: Props) {
  const { t } = useTranslate();

  if (props.priceHubbleHistory?.length === 0) {
    const infoText = props.isFlat
      ? t('evaluation_price_hubble_development_widget_info_text_flat')
      : t('evaluation_price_hubble_development_widget_info_text_house');
    return (
      <div className="h-full flex flex-col gap-y-6">
        <div>
          <EmptyState
            title={t('evaluation_price_hubble_development_widget_title')}
            description={infoText}
          />
        </div>
      </div>
    );
  }

  const infoText = props.isFlat
    ? t('evaluation_price_hubble_development_widget_info_text_flat')
    : t('evaluation_price_hubble_development_widget_info_text_house');

  return (
    <div className="h-full flex flex-col gap-y-6">
      <div className="flex flex-col gap-1">
        <h2 className="text-lg font-bold">
          {t('evaluation_price_hubble_development_widget_title')}
        </h2>
        {!props.showFullText && (
          <p className="text-sm text-slate-600 dark:text-slate-400">
            {infoText}
          </p>
        )}
      </div>

      {props.showFullText && (
        <p className="text-slate-700 dark:text-slate-300">{infoText}</p>
      )}

      <PriceDevelopmentHistoryChart
        datasetIdKey={'priceDevelopment'}
        priceHubbleHistory={props.priceHubbleHistory}
      />
    </div>
  );
}
